import React, { useEffect, useState } from "react";
import PageLayout from "../../../components/PageLayout";
import TickIcon from "../../../assets/images/lystfacelogos/CompletedIcon.svg"
import config, { devUrls, urls } from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { checkPlanLimit, getPlansList, resetResponseStatus, setShowEstimationScreen } from "../../../store/menu/pricing/actions";
import CustomLoader from "../../../components/Common/CustomLoader";
import CustomPopup from "../../../components/Common/CustomPopup";
import { useNavigate } from "react-router-dom";
import { AlertIcon, CompletedTickIcon } from "../../../components/Common/SvgIcons";
import EstimationScreen from "./EstimationScreen";
import { isNotNullOrUndefined } from "../../../common/functions";
import { Elements } from "@stripe/react-stripe-js"
import StripeProvider from "../../../components/Common/StripeProvider";
import { resetPlanResponse, setPayementInformation } from "../../../store/actions";
import { CustomToast } from "../../../components/Lystface/Common/CustomToast";
import { appConstants } from "../../../constants/app_constants";


const Pricing = () => {
    const pageName = "Settings"
    const moduleName = "Pricing"
    const dispatch = useDispatch();
    const PricingState = useSelector(state => state.Pricing)
    const { planDetails: { planMappings: planList, loading: planListLoading, currentPlan: currentPlan, is_trial, downSchedule, cancelSchedule, upcomingPlan }, showEstimationScreen, planLimit: { loading: planLimitLoading, response: planLimitDetails, planId: selectedPlanId, responseCode: planLimitResponseCode, responseMessage: planLimitResponseMessage } } = PricingState
    const [popupDetails, setPopupDetails] = useState(false);
    const { supportEmail } = config.messages
    const navigate = useNavigate();
    const PlanUserState = useSelector(state => state.Plan)
    const { externalPlanId } = PlanUserState
    const currenPlanId = currentPlan
    const ConstDetailsProp = useSelector(state => state.Login.constDetails)
    const { card_setup } = ConstDetailsProp


    useEffect(() => {
        if (planLimitResponseCode && !planLimitLoading && isNotNullOrUndefined(planLimitResponseMessage)) {
            handleLimitCheckSucess(parseInt(selectedPlanId))
        }
        else if (!planLimitResponseCode && planLimitResponseMessage) {
            CustomToast({
                message: planLimitResponseMessage,
                status: 'failure',
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            // dispatch(resetResponseStatus())

        }

    }, [planLimitResponseMessage, planLimitLoading, planLimitResponseCode])

    useEffect(() => {
        dispatch(getPlansList({}))
        dispatch(resetPlanResponse())
        return () => {
            dispatch(resetResponseStatus())
            dispatch(setShowEstimationScreen({ show: false }))
        }
    }, [])


    const breadcrumbItems = [
        { text: "Home", link: "/" },
        { text: pageName, link: "#" },
        { text: moduleName, link: "#" },
    ]

    const handleClickPrimaryButton = () => {
        setPopupDetails({ open: false })
        if (showEstimationScreen) {
            dispatch(setShowEstimationScreen({ show: false }))
        }
    }

    const handleClose = () => {
        setPopupDetails({ open: false })
    }
    const handleNavigateApplication = () => {
        navigate("/application")
    }

    const handleDowngrade = () => {
        setPopupDetails({ open: false })
        dispatch(setShowEstimationScreen({ show: true, type: "downgrade", planId: selectedPlanId }))

    }

    const handleLimitCheckSucess = (planId) => {
        if (currenPlanId > planId) {
            if (planLimitDetails?.overallCheck && !showEstimationScreen) {
                setPopupDetails({
                    open: true, titleText: "Plan transition",
                    bodyText: <div className="pricing-container"><p className="title">By switching to the {planLimitDetails?.planName} plan , you will lose access to premium features. Are you sure you want to continue?</p>
                        <p className="support-text">For further assistance, please reach us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a></p></div>,
                    primaryButtonText: 'Continue', secondaryButtonText: "Stay on same plan", handleClickSecondaryButton: handleClose, handleClickPrimaryButton: handleDowngrade, handleClose: handleClose, className: "pricing"
                })
            }
            else if (!planLimitDetails?.overallCheck) {
                setPopupDetails({
                    open: true, titleText: "Plan change alert",
                    bodyText: <div className="pricing-container"><p className="title">Switching to the {planLimitDetails?.planName} plan will result in a loss of access to some apps, storage, and galleries.</p>
                        <div className="usage-container">
                            <p className="title">Current plan</p>
                            <div className="usage-details">
                                <div className="usage-check">
                                    <div className={`icon ${planLimitDetails?.appCheck ? "" : "danger"}`} >

                                        {planLimitDetails?.appCheck ? CompletedTickIcon : AlertIcon}
                                    </div>
                                    <div>
                                        <span className={`bold ${planLimitDetails?.appCheck ? "success" : "danger"}`}>Apps: {planLimitDetails?.appCurrent} apps</span> {!planLimitDetails?.appCheck && <span>({planLimitDetails?.planName} plan allows {planLimitDetails?.appAllowed} app)</span>}
                                    </div>
                                </div>
                                <div className="usage-check">
                                    <div className={`icon ${planLimitDetails?.storageCheck ? "" : "danger"}`}>
                                        {planLimitDetails?.storageCheck ? CompletedTickIcon : AlertIcon}
                                    </div>
                                    <div>
                                        <span className={`bold ${planLimitDetails?.storageCheck ? "success" : "danger"}`}>Storage: {planLimitDetails?.storageCurrent} faces {!planLimitDetails?.storageCheck && "used"}</span> {!planLimitDetails?.storageCheck && <span>({planLimitDetails?.planName} plan allows {planLimitDetails?.storageAllowed} faces)</span>}
                                    </div>
                                </div>
                                <div className="usage-check">
                                    <div className={`icon ${planLimitDetails?.galleryCheck ? "" : "danger"}`}>
                                        {planLimitDetails?.galleryCheck ? CompletedTickIcon : AlertIcon}
                                    </div>
                                    <div>
                                        <span className={`bold ${planLimitDetails?.galleryCheck ? "success" : "danger"}`}>Galleries: {planLimitDetails?.galleryCurrent}</span> {!planLimitDetails?.galleryCheck && <span>({planLimitDetails?.planName} plan allows {planLimitDetails?.galleryAllowed} galleries)</span>}

                                    </div>
                                </div>
                            </div>
                        </div >
                        <p className="support-text">For further assistance, please reach us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a></p></div >,
                    primaryButtonText: 'Stay on same plan', secondaryButtonText: "Manage applications", handleClickSecondaryButton: handleNavigateApplication, handleClickPrimaryButton: handleClickPrimaryButton, handleClose: handleClose, className: "pricing"
                })
            }



        }
    }
    const handleClickAddCard = () => {
        dispatch(setPayementInformation({ from: "payment-information" }))
        navigate('/settings/billing-details')
    }

    const handleChangePlan = (planId, card_setup) => {
        if (!card_setup) {
            setPopupDetails({
                open: true, titleText: `Change Plan `,
                bodyText: <div className="billing"><p>To change plan, please setup your billing information.</p><span>Note: You will be charged once your trial plan ends.</span></div>,
                primaryButtonText: 'Add card', secondaryButtonText: 'Cancel', handleClickPrimaryButton: handleClickAddCard, handleClickSecondaryButton: handleClose, handleClose: handleClose
            })
        }
        else if (downSchedule) {
            if (currenPlanId > planId) {
                const isSamePlan = planList.find(obj => obj?.planId === planId)?.planName === upcomingPlan
                if (isSamePlan) {
                    setPopupDetails({
                        open: true, titleText: `Plan change scheduled`,
                        bodyText: <div className="plans"><p>Your plan change to {upcomingPlan} is scheduled and will take effect at the end of your billing cycle. </p><span>You will be notified once your plan is updated. </span></div>,
                        primaryButtonText: 'Close', handleClickPrimaryButton: handleClose, handleClose: handleClose
                    })

                }
                else {
                    setPopupDetails({
                        open: true, titleText: `Plan change scheduled`,
                        bodyText: <div className="plans"><p>Your plan change to {upcomingPlan} is scheduled and will take effect at the end of your billing cycle. To change your plan, please wait until this plan change is complete.</p><span>You will be notified once your plan is updated, after which further changes will be available. </span></div>,
                        primaryButtonText: 'Close', handleClickPrimaryButton: handleClose, handleClose: handleClose
                    })
                }

            }
            else {
                setPopupDetails({
                    open: true, titleText: `Plan change scheduled`,
                    bodyText: <div className="plans"><p>Your plan change to {upcomingPlan} is scheduled and will take effect at the end of your billing cycle. To upgrade, please wait until this change is complete.</p><span>You will be notified once your plan is updated, after which further upgrades will be available. </span></div>,
                    primaryButtonText: 'Close', handleClickPrimaryButton: handleClose, handleClose: handleClose
                })
            }

        }
        else if (cancelSchedule) {
            if (currenPlanId > planId) {
                setPopupDetails({
                    open: true, titleText: `Cancellation Scheduled`,
                    bodyText: <div className="plans"><p>Your current subscription is scheduled for cancellation at the end of your billing cycle.You will be notified once the cancellation is complete, after which you can proceed with a downgrade.</p></div>,
                    primaryButtonText: 'Close', className: "pricing", handleClickPrimaryButton: handleClose, handleClose: handleClose,
                })
            }
            else {
                setPopupDetails({
                    open: true, titleText: `Cancellation Scheduled`,
                    bodyText: <div className="plans"><p>Your current subscription is scheduled for cancellation at the end of your billing cycle.You will be notified once the cancellation is complete, after which you can proceed with an upgrade.</p></div>,
                    primaryButtonText: 'Close', className: "pricing", handleClickPrimaryButton: handleClose, handleClose: handleClose
                })
            }

        }
        else if (currenPlanId > planId) {
            dispatch(checkPlanLimit({ plan: planId.toString() }))
        }
        else {
            if (currenPlanId) {
                if (is_trial) {
                    dispatch(setShowEstimationScreen({ show: true, type: "upgrade", planId, active_trial: true }))

                }
                else {
                    dispatch(setShowEstimationScreen({ show: true, type: "upgrade", planId }))

                }

            }
            else {
                dispatch(setShowEstimationScreen({ show: true, type: "resubscribe", planId }))

            }

        }


    }
    const stripeApiKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    const stripe = StripeProvider(stripeApiKey);

    return (
        <React.Fragment>
            <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems}>
                <div className={`${showEstimationScreen && !planListLoading ? "estimation-screen" : "pricing-card"}`}>
                    {planListLoading ?
                        <CustomLoader text={"Fetching plan list..."} />
                        :
                        !planList && !planListLoading ?
                            <p>No data</p>
                            :
                            showEstimationScreen ?
                                <Elements stripe={stripe} >
                                    <EstimationScreen planList={planList} currenPlanId={currenPlanId} />
                                </Elements>
                                :
                                <>
                                    <span className="title">Compare offerings</span>
                                    <div className="plans-container">
                                        {planList?.map((plan, index) => (
                                            <div className="plan" key={plan?.planId}>
                                                <span className="name">{plan.planName}</span>
                                                <span className="transaction">{plan.planPrice}</span>
                                                <span className="transaction-min">{plan.addonCostPerTrans}</span>

                                                <div>
                                                    <button onClick={() => handleChangePlan(plan?.planId, card_setup)} className={`${plan?.planName === upcomingPlan ? "downgrade-scheduled" : currenPlanId === plan?.planId || (planLimitLoading && selectedPlanId === plan?.planId.toString()) || downSchedule || cancelSchedule ? "disabled" : currenPlanId > plan?.planId ? "change-plan" : ""}`} disabled={currenPlanId === plan?.planId || (planLimitLoading && selectedPlanId === plan?.planId.toString()) || cancelSchedule || downSchedule}>{plan?.planName === upcomingPlan ? "Downgrade scheduled" : currentPlan === null ? "Choose plan" : currenPlanId === plan?.planId ? "Current plan" : currenPlanId > plan?.planId ? "Change plan" : "Upgrade now"}
                                                        {(planLimitLoading && selectedPlanId === plan?.planId.toString()) && <div className="spinner-container spinner-border">
                                                        </div>}
                                                    </button>

                                                </div>
                                                <div className="check-list">
                                                    <div className="check-item">
                                                        <img src={TickIcon} />
                                                        <span >{plan?.trialTrans} {plan?.trialCount}</span>

                                                    </div>
                                                    <div className="check-item">

                                                        <img src={TickIcon} />
                                                        <span >{plan?.appsLimit}</span>
                                                    </div>
                                                    <div className="check-item">

                                                        <img src={TickIcon} />
                                                        <span >{plan?.transPerMin}</span>
                                                    </div>
                                                    <div className="check-item">

                                                        <img src={TickIcon} />
                                                        <span >{plan?.storageLimit}</span>
                                                    </div>
                                                    <div className="check-item">

                                                        <img src={TickIcon} />
                                                        <span >{plan?.galleryLimit}</span>
                                                    </div>

                                                </div>
                                            </div>



                                        ))}
                                    </div>
                                    <span className="footer-text">*Storage for up to 750,000 face images are included in enterprise plan. Additional storage fees apply for larger galleries.<br />
                                        **Credit card required to start free trial. New customers only. Cancel anytime. See {appConstants.cName} <a href={process.env.REACT_APP_NODE !== "prod" ? devUrls.lfTermsCnds : urls.lfTermsCnds} target="_blank">Terms of Use</a> for more information.</span>
                                </>
                    }
                </div>
                {
                    popupDetails.open &&
                    <CustomPopup popupDetails={popupDetails} />
                }
            </PageLayout>
        </React.Fragment >
    )
}

export default Pricing